// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#_snippets{$oy:auto;$wos:touch;$p:10px}#_snippets ._section{$mb:10px;$bo:1px solid var(--border);$o:hidden;$cu:pointer}#_snippets ._section:active ._name{$b:var(--highlight);$c:var(--select-foreground)}#_snippets ._section ._name{$p:10px;$c:var(--primary);$b:var(--darker-background);$tr:background .3s}#_snippets ._section ._name ._btn{$ml:10px;$f:right;$ta:center;$w:18px;$h:18px;$lh:18px;$fs:12px}#_snippets ._section ._description{$c:var(--foreground);$p:10px;$tr:background .3s}", ""]);
// Exports
module.exports = exports;
